import React, { useEffect, useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Pagination,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ButtonGroup,
  CircularProgress,
  Backdrop
} from '@mui/material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

function InvoiceForProductDay() {
  const [datosGenerados, setDatosGenerados] = useState([]);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [filtroTexto, setFiltroTexto] = useState("");
  const [filtroTienda, setFiltroTienda] = useState("");
  const [filtroCaja, setFiltroCaja] = useState("");
  const [tiendas, setTiendas] = useState([]);
  const [cajas, setCajas] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [elementosPorPagina] = useState(50);
  const [loading, setLoading] = useState(false); // Estado para el indicador de carga

  const fetchData = () => {
    setLoading(true); // Activar el indicador de carga
    
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321"
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril"
      },
      DatosMetodo: {
        NombreMetodo: "ListaReportesSalas",
        Datos_Recibidos: `{"Vista":"ReporteVentas", "FechaIni":"${fechaInicio}","FechaFin":"${fechaFin}"}`
      }
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;

    fetch(fetchDataUrl)
      .then(response => response.json())
      .then(data => {
        try {
          if (data && data.datos_Generados) {
            const datosGeneradosLimpiados = data.datos_Generados.replace(/\\\\"/g, '"').replace(/\\\\/g, '\\');
            const datosGeneradosDecodificados = JSON.parse(datosGeneradosLimpiados);
            setDatosGenerados(datosGeneradosDecodificados);
            
            // Extraer cajas únicas basadas en la tienda seleccionada
            const cajasUnicas = [...new Set(
              datosGeneradosDecodificados
                .filter(item => !filtroTienda || item.Sala === filtroTienda)
                .map(item => item.Caja)
            )].sort();
            
            setCajas(cajasUnicas);
          } else {
            console.error("No se recibieron datos generados válidos:", data);
          }
        } catch (error) {
          console.error("Error al decodificar los datos generados:", error);
        }
      })
      .catch(error => console.error('Error:', error))
      .finally(() => {
        setLoading(false); // Desactivar el indicador de carga
      });
  };

  useEffect(() => {
    // Simulación de carga de tiendas
    setTiendas([" ", "TZ10", "TPRR", "TSCR", "TCSV", "TMIR", "TXLA"]);
  }, []);

  // Actualizar cajas cuando cambia la tienda seleccionada
  useEffect(() => {
    if (datosGenerados.length > 0) {
      const cajasFiltradas = [...new Set(
        datosGenerados
          .filter(item => !filtroTienda || item.Sala === filtroTienda)
          .map(item => item.Caja)
      )].sort();
      setCajas(cajasFiltradas);
    }
  }, [filtroTienda, datosGenerados]);

  const handleSearch = () => {
    fetchData();
  };

  const handlePageChange = (event, value) => {
    setPaginaActual(value);
  };

  const limpiarJSON = (jsonString) => {
    return jsonString.replace(/\\\\"/g, '"').replace(/\\\\/g, '\\');
  };

  // Filtrar los datos según los filtros aplicados
  const filteredData = datosGenerados.flatMap(item => {
    try {
      const detalle = JSON.parse(limpiarJSON(item.Detalle)).DETALLE || [];
      return detalle.filter(prod => {
        const searchValue = filtroTexto.toLowerCase();
        const filtroPorTienda = filtroTienda ? item.Sala === filtroTienda : true;
        const filtroPorCaja = filtroCaja ? item.Caja === filtroCaja : true;
        
        return (
          (prod.ItemCode.toLowerCase().includes(searchValue) ||
          prod.Dscription.toLowerCase().includes(searchValue)) &&
          filtroPorTienda &&
          filtroPorCaja &&
          (prod.Price > 0)
        );
      }).map(prod => {
        const partesFecha = item.DocDate.split('/');
        const fechaFormateada = `${partesFecha[0]}/${partesFecha[1]}/${partesFecha[2]}`;

        return {
          Caja: item.Caja,
          Fecha: fechaFormateada,
          NumFactura: item.DocNum,
          nit: item.nit,
          Cliente: item.Cliente,
          Codigo: prod.ItemCode,
          Descripcion: prod.Dscription,
          UnidadesVendidas: prod.Cantidad,
          Costo: prod.Price || 0,
          TotalNeto: prod.Total_Neto,
          Estado: item.Estado,
          Tienda: item.Sala
        };
      });
    } catch (error) {
      console.error("Error al procesar el detalle:", error);
      return [];
    }
  });

  // Paginación
  const indexUltimoElemento = paginaActual * elementosPorPagina;
  const indexPrimerElemento = indexUltimoElemento - elementosPorPagina;
  const datosPaginados = filteredData.slice(indexPrimerElemento, indexUltimoElemento);

  // Funciones para exportar
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("REPORTE PRODUCTOS POR FECHA", 20, 10);
    doc.autoTable({
      head: [['Caja', 'Fecha', 'Factura', 'NIT', 'Cliente', 'Código', 'Descripción', 'Unidades Vendidas', 'Costo','Total Neto', 'Estado']],
      body: filteredData.map(row => [
        row.Caja,
        row.Fecha,
        row.NumFactura,
        row.nit,
        row.Cliente,
        row.Codigo,
        row.Descripcion,
        row.UnidadesVendidas,
        row.Costo,
        row.TotalNeto,
        row.Estado
      ]),
    });
    doc.save('facturas.pdf');
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ReporteProductos");
    XLSX.writeFile(workbook, 'facturas.xlsx');
  };

  return (
    <Container>
      {/* Backdrop para el loading */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <h1>FACTURAS</h1>
      <hr />
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
        <TextField
          id="filtroTexto"
          label="Buscar"
          value={filtroTexto}
          onChange={(e) => setFiltroTexto(e.target.value)}
          variant="outlined"
          style={{ width: '200px' }}
        />
        
        <FormControl variant="outlined" style={{ width: '150px' }}>
          <InputLabel id="filtro-tienda-label">Tienda</InputLabel>
          <Select
            labelId="filtro-tienda-label"
            value={filtroTienda}
            onChange={(e) => {
              setFiltroTienda(e.target.value);
              setFiltroCaja(""); // Resetear filtro de caja al cambiar tienda
            }}
            displayEmpty
            renderValue={(selected) => (selected === "" ? "Todas las tiendas" : selected)}
          >
            <MenuItem value="">
              <em>Todas las tiendas</em>
            </MenuItem>
            {tiendas.map((tienda, index) => (
              <MenuItem key={index} value={tienda}>
                {tienda}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" style={{ width: '150px' }}>
          <InputLabel id="filtro-caja-label">Caja</InputLabel>
          <Select
            labelId="filtro-caja-label"
            value={filtroCaja}
            onChange={(e) => setFiltroCaja(e.target.value)}
            displayEmpty
            disabled={!filtroTienda} // Deshabilitar si no hay tienda seleccionada
            renderValue={(selected) => (selected === "" ? "Todas las cajas" : selected)}
          >
            <MenuItem value="">
              <em>Todas las cajas</em>
            </MenuItem>
            {cajas.map((caja, index) => (
              <MenuItem key={index} value={caja}>
                {caja}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          id="fechaInicio"
          label="Fecha Inicio"
          type="date"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          style={{ width: '200px' }}
        />

        <TextField
          id="fechaFin"
          label="Fecha Fin"
          type="date"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          style={{ width: '200px' }}
        />

        <Button 
          variant="contained" 
          onClick={handleSearch}
          disabled={loading} // Deshabilitar el botón durante la carga
        >
          {loading ? 'Buscando...' : 'Buscar'}
        </Button>
        
        <ButtonGroup variant="contained">
          <Button onClick={exportToPDF} color='warning'>PDF</Button>
          <Button onClick={exportToExcel} color='success'>Excel</Button>
        </ButtonGroup>
      </div>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tienda</TableCell>
            <TableCell>Caja</TableCell>
            <TableCell>Fecha</TableCell>
            <TableCell>NumFactura</TableCell>
            <TableCell>NIT</TableCell>
            <TableCell>Cliente</TableCell>
            <TableCell>Código</TableCell>
            <TableCell>Descripción</TableCell>
            <TableCell>Unidades Vendidas</TableCell>
            <TableCell>Costo</TableCell>
            <TableCell>Total</TableCell>
            <TableCell>Estado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datosPaginados.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.Tienda}</TableCell>
              <TableCell>{item.Caja}</TableCell>
              <TableCell>{item.Fecha}</TableCell>
              <TableCell>{item.NumFactura}</TableCell>
              <TableCell>{item.nit}</TableCell>
              <TableCell>{item.Cliente}</TableCell>
              <TableCell>{item.Codigo}</TableCell>
              <TableCell>{item.Descripcion}</TableCell>
              <TableCell>{item.UnidadesVendidas}</TableCell>
              <TableCell>{item.Costo}</TableCell>
              <TableCell>{item.TotalNeto}</TableCell>
              <TableCell>{item.Estado}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Pagination
        count={Math.ceil(filteredData.length / elementosPorPagina)}
        page={paginaActual}
        onChange={handlePageChange}
        color="primary"
      />
    </Container>
  );
}

export default InvoiceForProductDay;